function WorkStation() {
	return (
		<svg version="1.1"  xmlns="http://www.w3.org/2000/svg" 
			viewBox="0 0 512 512" className="w-5">
		<g>
			<g>
				<rect x="41.796" y="94.041" width="271.673" height="156.735"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M20.898,282.122v10.449c0,17.312,14.035,31.347,31.347,31.347H303.02c17.312,0,31.347-14.035,31.347-31.347v-10.449
					H20.898z"/>
			</g>
		</g>
		<g>
			<g>
				<rect y="355.265" width="501.551" height="41.796"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M494.997,178.01l-64.667-83.143l-0.188,0.146c3.774-13.892,3.139-29.093-2.849-43.402
					c-14.291-34.145-53.556-50.24-87.701-35.948l51.754,123.65c8.588-3.594,16.032-8.772,22.14-15.048l56.78,73.003
					c-0.025,0.419-0.062,0.835-0.062,1.258c0,0.425,0.039,0.841,0.064,1.26l-56.024,72.031c-27.118,1.909-48.529,24.497-48.529,52.1
					h104.49c0-18.045-9.149-33.953-23.061-43.34l47.848-61.518c4.1-0.768,7.874-2.739,10.888-5.751
					c3.949-3.949,6.123-9.199,6.121-14.778C512,188.34,504.663,179.841,494.997,178.01z"/>
			</g>
		</g>
		<g>
			<g>
				<rect x="31.347" y="428.408" width="41.796" height="73.143"/>
			</g>
		</g>
		<g>
			<g>
				<rect x="428.408" y="428.408" width="41.796" height="73.143"/>
			</g>
		</g>
		</svg>
	)
}

export default WorkStation